import { render, staticRenderFns } from "./knowledge1.vue?vue&type=template&id=552754bd&scoped=true"
import script from "./knowledge1.vue?vue&type=script&lang=js"
export * from "./knowledge1.vue?vue&type=script&lang=js"
import style0 from "./knowledge1.vue?vue&type=style&index=0&id=552754bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552754bd",
  null
  
)

export default component.exports